module.exports = __webpack_public_path__ + "img/three-dots.20b2f4d8.svg";